import { Button } from '@e2n/ui/v2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { KontoausgleichForm } from '@/domain/mitarbeiter/features/feiertagskonto/features/kontoausgleich/KontoausgleichForm';

export function KontoausgleichHinzufügen() {
  const { t } = useTranslation();
  return (
    <KontoausgleichForm>
      <Button
        variant="primary-pill"
        iconOnly
        size="medium"
        aria-label={
          t('domain.mitarbeiter.feiertagskonto.kontoausgleich.titel') +
          ' ' +
          t('actions.hinzufügen')
        }>
        <FontAwesomeIcon icon={faPlus} className="size-4" />
      </Button>
    </KontoausgleichForm>
  );
}
